import React, { useContext, useState } from "react";
import PostFormStyles from "../../Styles/PostsViews/postForm.module.css";
import { faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Input from "../../Common/Input.component/Input";
import { ContextForClient } from "../../Context_file/ClientContext";
import { postRequest } from "../../helper/CustomPost";

const PostForm = () => {
  const [texts, settext] = useState("");
  const [{ channelName }, dispatch] = useContext(ContextForClient);
  const { form, postBtn, input } = PostFormStyles;

  const handlePostText = async (e) => {
    e.preventDefault();
    const url = `posttext?channel=${channelName}`,
      storage = "newpost",
      data = { text: texts, channel: channelName };

    await postRequest({ url, storage, dispatch, data });

    settext("");
  };

  return (
    <div className={`${form}`}>
      <form className={`form-group`} onSubmit={(ref) => handlePostText(ref)}>
        <Input
          type={"text"}
          name="post"
          className={`border-0 form-control-lg ${input}`}
          placeholder="type a message here..."
          value={texts}
          backgroundColor="#333"
          color="#fff"
          autoComplete="off"
          onChange={(ref) => settext(ref.target.value)}
        />
        <span className={postBtn}>
          <FontAwesomeIcon
            icon={faAngleDoubleRight}
            style
            size="2x"
            onClick={(ref) => handlePostText(ref)}
            cursor="pointer"
            title="save"
            color="#fff"
          />
        </span>
      </form>
    </div>
  );
};

export default PostForm;
